export const WMWAnswers = [
	['seng', 'fot'],
	['is', 'ku'],
	['glas', 'saks', 'hus'],
	['bil', 'ku', 'sol'],
	['is', 'blome', 'fot', 'ball'],
	['bamse', 'auge', 'hest', 'fly'],
	['genser', 'øyre', 'stol', 'hand', 'løve'],
	['glas', 'ku', 'måne', 'bil', 'vatn'],
	['bukse', 'tv', 'baby', 'eple', 'gåve', 'ski'],
	['avis', 'bilde', 'kopp', 'katt', 'snø', 'vegg'],
	['fly', 'penn', 'banan', 'pil', 'blå', 'stjerne', 'boks'],
	['skole', 'jakke', 'kaffi', 'briller', 'sykkel', 'gut', 'vindauge'],
];

export const WMNAnswers = [
	[7, 3],
	[9, 2],
	[8, 5, 1],
	[9, 4, 2],
	[1, 8, 4, 3],
	[3, 7, 2, 6],
	[5, 3, 7, 2, 1],
	[4, 1, 3, 6, 9],
	[1, 9, 5, 2, 7, 8],
	[3, 9, 7, 2, 4, 1],
	[1, 9, 4, 8, 3, 5, 2],
	[2, 7, 4, 1, 7, 9, 6],
];

export const WMNTrialAnswers = [[8, 5]];
export const WMWTrialAnswers = [];

export const WMNTrialOlderVersionAnswers = [
	[8, 5],
	[2, 9],
];
export const WMWTrialOlderVersionAnswers = [
	['Sol', 'Fly'],
	['Fisk', 'Ski'],
];

export const SM_trialSentences = ['Katten søv i senga'];
export const SM_testSentences = [
	'Eg et eit raudt eple kvar dag',
	'Huset vårt er stort og kvitt og har mange vindauge',
	'Kaninen hoppar over gjerdet og gøymer seg i buskane',
	'I går leikte vi i parken heile dagen med vennane våre',
	'Fuglen flaug høgt på den blå himmelen og landa på et tre',
	'Den vesle guten mista den blå ballen sin i elva og blei veldig lei seg',
	'Til hausten skal vi ut i skogen og plukke sopp og bær som vi skal sylte',
	'Ho fann ein gammal nøkkel som låg under den store steinen i hagen',
	'Bestemor fortalde ei artig historie om då ho var lita og gjekk på skolen',
	'Vi gjekk ein lang tur innover dalen, og møtte mange dyr på vegen, som ekorn og elg',
];

export const SM_trialSentencesUpper = [
	'Himmelen var full av stjerner i går kveld',
];

export const SM_testSentencesUpper = [
	'Blada på trea skifta farge då hausten kom',
	'Biblioteket, som ligg midt i byen, har mange spennande bøker',
	'Reven, som hadde lege stille i skuggen av treet, lista seg stille fram',
	'Eg liker å høyre på musikk mens eg gjer lekser og ryddar på rommet',
	'Læraren gruer seg til å ta farvel med den herlege klassen siste skoledag',
	'I helga besøkte vi besteforeldra mine, som bur på en gard med mange forskjellige dyr',
	'På torsdag skal vi møtast heime hos ein i klassen for å ete pizza og sjå ein skummel film',
	'Han fann ei nedstøva skattkiste i kjellaren, som var full av gamle myntar',
	'Tante fortalde om dei fargerike kleda som var moderne då hun var ung',
	'Vi gjekk ein lang tur langs stranda, kor vi samla skjel og såg på bølgene som slo mot land',
];

export const SM_youth_trialSentences = [
	'Skyene på himmelen bevega seg sakte over fjelltoppene',
];

// Youth followup – test sentences (NO) For now // must be replaced with NN version
export const SM_youth_testSentences = [
	'Himmelen var dekka av mørke skyer, og vinden blåste kraftig gjennom trea',
	'Vi drog på ein lang fjelltur, der vi såg både reinsdyr, ørner og vakre fossefall',
	'Biblioteket, som blei pussa opp i fjor, har eigne hyller for ungdomsbøker',
	'Reven, som hadde gøymt seg bak ein stein, venta tolmodig på bytet sitt',
	'I sommar besøkte vi ein liten landsby ved kysten, der vi åt fersk sjømat kvar dag',
	'Eg liker å høyre på podkastar om vitskap og teknologi mens eg ryddar i klesskapet mitt',
	'På laurdag skal vi ha filmkveld heime, der vi skal sjå klassiske filmar og ete popkorn',
	'Læraren vår fortalde oss om den gongen han reiste til ei aude øy og budde der i fleire veker',
	'Vi gjekk ein lang tur langs elva, der vi såg fisk og ein stor bever som bygde ein demning',
	'På museet skal vi sjå ei utstilling om verdsrommet, med modellar av planetar og stjerner',
	'Eg las ein lang artikkel om korleis klimaendringar påverkar dyrelivet i Arktis',
	'Vi besøkte ei gammal borg, der vi lærte om riddarar i mellomalderen og livet deira',
];

// Adult followup – trial sentences (NO) For now. Must be replaced with NN later
export const SM_adult_trialSentences = [
	'Regndropane tromma mot vindauga mens vinden ulte gjennom trea',
];

// Adult followup – test sentences (NO) For now. Must be repalced with NN later
export const SM_adult_testSentences = [
	'Skyene samla seg på himmelen, og eit kraftig torevêr var på veg',
	'Biblioteket, som har ei stor samling av klassisk litteratur, er ein populært stad for studentar',
	'Reven, som hadde venta lenge, hoppa fram då bytet endeleg dukka opp',
	'Eg gleder meg til sommarferien, når vi skal reise til ei eksotisk øy med kvite strender',
	'I haustferien besøkte vi ein historisk by, der vi lærte om arkitektur frå mellomalderen',
	'Eg liker å høyre på podkastar om vitskap og teknologi mens eg vaskar hybelen min',
	'På laurdag skal vi arrangere ein middag i nabolaget, der vi skal lage spennande matrettar frå forskjellige land',
	'Han fann ei gammal bok som inneheldt handskrivne notat frå 1800-tallet',
	'Vi gjekk ein lang tur langs elvebredda, der vi såg både fisk, fuglar og ein beverdam',
	'På vitensenteret såg vi ei utstilling om verdsrommet, med detaljerte modellar av galaksar og planetar',
	'Eg las ein interessant forskingsartikkel om korleis kunstig intelligens kan endre arbeidsmarknaden',
	'Vi besøkte ein gammal katedral, der vi lærte om gotisk arkitektur og historie',
];

// Non-word repetition – child followup (NO)
export const nonword_child_trialWords = [
	// practice item(s) – you can tweak text to match exactly the recording
	'Kap',
];

export const nonword_child_testWords = [
	'Kjæf', // 1  (long vowel)
	'Nælle', // 3
	'Skjaile', // 5
	'Finglar', // 7
	'Kjipler', // 8
	'Øplin', // 9
	'Kjaflende', // 12
	'Ufibberang', // 13
	'Kjimplerank', // 15
	'Flångsteront', // 16
];

// Non-word repetition – youth followup (NO)
export const nonword_youth_trialWords = [
	// practice item
	'Skjofenal',
];

export const nonword_youth_testWords = [
	// 1–16 in the same order as the Y audio files
	'Sprølt', // 1
	'Kvolp', // 2
	'Trompelten', // 4
	'Skjålving', // 5
	'Drøvlesker', // 7
	'Klympensk', // 8
	'Strævlinger', // 9
	'Øflotterong', // 10
	'Kjasternest', // 11
	'Brångelsvikt', // 12
	'Flangsterinter', // 15
	'Nevrinatalske', // 16
];

export const nonword_adult_trialWords = ['Skjofenal'];

export const nonword_adult_testWords = [
	'Kjolter', // 1
	'Ublømst', // 3
	'Sumpeltansk', // 4
	'Pinketargen', // 5
	'Skjohanger', // 6
	'Nangotisme', // 7
	'Klimpenansk', // 8
	'Stratinskere', // 9
	'Uklarterende', // 10
	'Ugrimelingst', // 12
	'Ulterabras', // 13
	'Nutrotisisme', // 16
];

export const SpoonerismAnswers = [
	{task: 'Bamse – Sofa', correct: ['Samse', 'Bofa']},
	{task: 'Lekse – Genser', correct: ['Gekse', 'Lenser']},
	{task: 'Sykkel – Rose', correct: ['Rykkel', 'Sose']},
	{task: 'Skinne – Hylle', correct: ['Hinne', 'Skylle']},
	{task: 'Fotball – Kake', correct: ['Kotball', 'Fake']},
	{task: 'Kiste – Munn', correct: ['Miste', 'Kjunn']},
	{task: 'Dommar – Brikke', correct: ['Bommar', 'Drikke']},
	{task: 'Sjelden – Boks', correct: ['Belden', 'Sjoks']},
	{task: 'Kaffe – Brødre', correct: ['Baffe', 'Krødre']},
	{task: 'Varme – Hjort', correct: ['Jarme', 'Vort']},
	{task: 'Hjerte – Bord', correct: ['Berte', 'Jord']},
	{task: 'Motor – Ballong', correct: ['Botor', 'Mallong']},
	{task: 'Serviett – Jukse', correct: ['Jerviett', 'Sukse']},
	{task: 'Skjerm – Hår', correct: ['Herm', 'Skjår']},
	{task: 'Kjeks – Mais', correct: ['Meks', 'Kjais']},
	{task: 'Hår – Skjorte', correct: ['Skjår', 'Horte']},
];

export const SpoonerismNormingAnswers = [
	{task: 'Mus – Hale', correct: ['Hus', 'Male']},
	{task: 'Ball – Tur', correct: ['Tall', 'Bur']},
	{task: 'Dør – Fisk', correct: ['Før', 'Disk']},
	{task: 'Hus – Bil', correct: ['Bus', 'Hil']},
	{task: 'Tær – Brød', correct: ['Bær', 'Trø']},
	{task: 'Bord – vindauge', correct: ['Vord', 'Bindauge']},
	{task: 'Matte – Norsk', correct: ['Natte', 'Morsk']},
	{task: 'Kropp – Tøff', correct: ['Tropp', 'Køff']},
	{task: 'Tavle – Nase', correct: ['Navle', 'Tase']},
	{task: 'Elv – Ørn', correct: ['Ølv', 'Ern']},
	{task: 'Skinne – Hylle', correct: ['Hinne', 'Skylle']},
	{task: 'Gjøre – Løk', correct: ['Løre', 'Jøk']},
];

export const SpoonerismIntroTasks = [
	{task: 'Bok - Dag', correct: ['Dok', 'Bag']},
	{task: 'Kjole - Fange', correct: ['Fole', 'Kjange']},
	{task: 'Musikk - Sjakk', correct: ['Sjusikk', 'Makk']},
];

export const SpoonerismNormingIntroTasks = [
	{task: 'Le - Fy', correct: ['Fe', 'Ly']},
	{task: 'Bok - Dag', correct: ['Dok', 'Bag']},
];

export const phonemeIsolationIntro = [
	{
		id: 0,
		sound: 'g',
		options: {
			a: 'ball',
			b: 'sweater',
			c: 'fish',
			d: 'ski',
		},
		correct: 'b',
	},
	{
		id: 1,
		sound: 'h',
		options: {
			a: 'telephone',
			b: 'flower',
			c: 'motorcycle',
			d: 'house',
		},
		correct: 'd',
	},
];

export const phonemeIsolationTasks = [
	{
		id: 0,
		sound: 'b',
		options: {
			a: 'apple',
			b: 'bicycle',
			c: 'book',
			d: 'tractor',
		},
		correct: 'c',
		type: 'starts_with_',
	},
	{
		id: 1,
		sound: 'k',
		options: {
			a: 'shoe',
			b: 'cat',
			c: 'flower',
			d: 'plane',
		},
		correct: 'b',
		type: 'starts_with_',
	},
	{
		id: 2,
		sound: 'i',
		options: {
			a: 'icecream',
			b: 'chair',
			c: 'baby',
			d: 'horse',
		},
		correct: 'a',
		type: 'starts_with_',
	},
	{
		id: 3,
		sound: 'oe',
		options: {
			a: 'fireengine',
			b: 'ear',
			c: 'cup',
			d: 'teddy',
		},
		correct: 'b',
		type: 'starts_with_',
	},
	{
		id: 4,
		sound: 's',
		options: {
			a: 'jeans',
			b: 'purse',
			c: 'key',
			d: 'bicycle',
		},
		correct: 'd',
		type: 'starts_with_',
	},
	{
		id: 5,
		options: {
			a: 'crocodile',
			b: 'shoe',
			c: 'ski',
			d: 'key',
		},
		correct: 'b',
		sound: 'o',
		type: 'ends_with_',
	},
	{
		id: 6,
		options: {
			a: 'cup',
			b: 'chair',
			c: 'horse',
			d: 'book',
		},
		correct: 'a',
		sound: 'p',
		type: 'ends_with_',
	},
];
export const phonemeIsolationNormingTasks = [
	{
		id: 0,
		sound: 'b',
		options: {
			a: 'apple',
			b: 'bicycle',
			c: 'book',
			d: 'tractor',
		},
		correct: 'book',
		type: 'starts_with_',
	},
	{
		id: 1,
		sound: 'l',
		options: {
			a: 'foot',
			b: 'doll',
			c: 'nose',
			d: 'lion',
		},
		correct: 'lion',
		type: 'starts_with_',
	},
	{
		id: 2,
		sound: 'k',
		options: {
			a: 'shoe',
			b: 'cat',
			c: 'flower',
			d: 'plane',
		},
		correct: 'cat',
		type: 'starts_with_',
	},
	{
		id: 3,
		sound: 'e',
		options: {
			a: 'elephant',
			b: 'spoon',
			c: 'bed',
			d: 'fish',
		},
		correct: 'elephant',
		type: 'starts_with_',
	},
	{
		id: 4,
		sound: 'i',
		options: {
			a: 'horse',
			b: 'chair',
			c: 'baby',
			d: 'icecream',
		},
		correct: 'icecream',
		type: 'starts_with_',
	},
	{
		id: 5,
		sound: 'v',
		options: {
			a: 'rabbit',
			b: 'gloves',
			c: 'tractor',
			d: 'boot',
		},
		correct: 'gloves',
		type: 'starts_with_',
	},
	{
		id: 6,
		sound: 'oe',
		options: {
			a: 'fireengine',
			b: 'ear',
			c: 'cup',
			d: 'teddy',
		},
		correct: 'ear',
		type: 'starts_with_',
	},
	{
		id: 7,
		sound: 's',
		options: {
			a: 'jeans',
			b: 'purse',
			c: 'key',
			d: 'bicycle',
		},
		correct: 'bicycle',
		type: 'starts_with_',
	},
	{
		id: 8,
		sound: 't',
		options: {
			a: 'foot',
			b: 'eye',
			c: 'sun',
			d: 'bed',
		},
		correct: 'foot',
		type: 'ends_with_',
	},
	{
		id: 9,
		options: {
			a: 'crocodile',
			b: 'shoe',
			c: 'ski',
			d: 'key',
		},
		correct: 'shoe',
		sound: 'o',
		type: 'ends_with_',
	},
	{
		id: 10,
		options: {
			a: 'jeans',
			b: 'banana',
			c: 'sweater',
			d: 'saft',
		},
		correct: 'banana',
		sound: 'n',
		type: 'ends_with_',
	},
	{
		id: 11,
		options: {
			a: 'tractor',
			b: 'fish',
			c: 'icecream',
			d: 'cat',
		},
		correct: 'tractor',
		sound: 'r',
		type: 'ends_with_',
	},
	{
		id: 12,
		options: {
			a: 'reflex',
			b: 'plane',
			c: 'book',
			d: 'plowtruck',
		},
		correct: 'plane',
		sound: 'y',
		type: 'ends_with_',
	},
	{
		id: 13,
		options: {
			a: 'chair',
			b: 'cup',
			c: 'horse',
			d: 'book',
		},
		correct: 'cup',
		sound: 'p',
		type: 'ends_with_',
	},
	{
		id: 14,
		options: {
			a: 'bicycle',
			b: 'package',
			c: 'finger',
			d: 'fireengine',
		},
		correct: 'package',
		sound: 'e',
		type: 'ends_with_',
	},
	{
		id: 15,
		options: {a: 'horse', b: 'cup', c: 'porrige', d: 'cow'},
		correct: 'cow',
		sound: 'u',
		type: 'ends_with_',
	},
];

export const oneMinuteTasks = [
	'har',
	'og',
	'til',
	'den',
	'med',
	'ikkje',
	'vil',
	'seg',
	'høyr',
	'bok',
	'ho',
	'vere',
	'blir',
	'skal',
	'over',
	'hus',
	'eller',
	'andre',
	'berre',
	'kroner',
	'mange',
	'mellom',
	'ete',
	'penn',
	'første',
	'gjer',
	'skole',
	'norsk',
	'kvifor',
	'store',
	'kveite',
	'godt',
	'flagg',
	'fortel',
	'tidlegare',
	'rundt',
	'gjennom',
	'sjakk',
	'derfor',
	'korleis',
	'allereie',
	'framleis',
	'samtidig',
	'viktig',
	'kvart',
	'mogeleg',
	'bjørn',
	'kjole',
	'kanskje',
	'desember',
	'vanskeleg',
	'linjal',
	'skjorte',
	'kikkert',
	'kvarandre',
	'kjøpe',
	'spørsmål',
	'akkurat',
	'eigentleg',
	'keramikk',
	'tiggar',
	'selskapet',
	'skjedde',
	'kylling',
	'autograf',
	'kiste',
	'hjort',
	'hjarte',
	'pennal',
	'laurdag',
	'gjær',
	'kakao',
	'spiseskei',
	'kjøtt',
	'utvikling',
	'elefant',
	'ryggsekk',
	'kyrkje',
	'hjerne',
	'gardinene',
	'leverpostei ',
	'helikopter',
	'rabarbra',
	'tyggegummi',
	'forskjellige',
	'trampoline',
	'protein',
	'fortau',
	'musikk',
	'heilomvending',
	'slikkepott',
	'situasjonen',
	'ambivalent',
	'kravstor',
	'segne',
	'binders',
	'flugelort',
	'peikefinger',
	'landsforrædar',
	'bilmekanikar',
	'skjere',
	'perforere',
	'samansetning',
	'hallusinasjon',
	'spekulasjon',
	'kjeldesortering',
	'akvakultur',
	'avdramatisere',
	'dyskalkuli',
	'makulering',
	'ukulele',
	'klinkekule',
	'beredskapsplan',
	'byggeindustri',
	'kjekjøtt',
	'skjermdump',
	'lakseoppdrett',
	'utdanningsprogram',
	'beskjedent',
	'riksmeklingsmannen',
];

export const lkAnswersNorming = [
	'O',
	'O',
	'T',
	'T',
	'W',
	'W',
	'H',
	'H',
	'C',
	'C',
	'E',
	'E',
	'Y',
	'Y',
	'M',
	'M',
	'B',
	'B',
	'Z',
	'Z',
	'Ø',
	'Ø',
	'V',
	'V',
	'K',
	'K',
	'G',
	'G',
	'R',
	'R',
	'S',
	'S',
	'Æ',
	'Æ',
	'F',
	'F',
	'I',
	'I',
	'P',
	'P',
	'J',
	'J',
	'L',
	'L',
	'D',
	'D',
	'N',
	'N',
	'Å',
	'Å',
	'Q',
	'Q',
	'U',
	'U',
	'X',
	'X',
	'A',
	'A',
];
export const lkAnswers = [
	'O',
	'O',
	'E',
	'E',
	'I',
	'I',
	'S',
	'S',
	'T',
	'T',
	'U',
	'U',
	'N',
	'N',
	'Å',
	'Å',
	'G',
	'G',
	'D',
	'D',
	'Æ',
	'Æ',
	'Q',
	'Q',
];
export const kdlkAnswers = [
	'H',
	'H',
	'E',
	'E',
	'M',
	'M',
	'B',
	'B',
	'G',
	'G',
	'R',
	'R',
	'S',
	'S',
	'Æ',
	'Æ',
	'F',
	'F',
	'I',
	'I',
	'J',
	'J',
	'L',
	'L',
	'D',
	'D',
	'N',
	'N',
	'U',
	'U',
];

export const pdIntroSteps = [
	{
		task: 'Kan du seie "gris"?',
		expectedAnswer: 'gris',
	},
	{
		task: 'Kan du seie "gris" utan /g/?',
		expectedAnswer: 'ris',
	},
];
export const pdSteps = [
	'gås',
	'mål',
	'brød',
	'klede',
	'brev',
	'trygg',
	'drap',
	'loff',
	'skyl',
	'lås',
	'bru',
	'klatre',
	'malt',
	'bry',
	'lekse',
	'sport',
];
export const pdAnswers = [
	'ås',
	'ål',
	'rød',
	'lede',
	'rev',
	'rygg',
	'rap',
	'lo',
	'sky',
	'lå',
	'bu',
	'klare',
	'mat',
	'by',
	'lese',
	'sort',
];

export const wdAnswersNorming = [
	'mase',
	'fly',
	'dra',
	'kråka',
	'melk',
	'tær',
	'rikke',
	'gråt',
	'bake',
	'regne',
	'hyle',
	'takk',
	'korleis',
	'verda',
	'ekkelt',
	'magisk',
	'ski',
	'leksefri',
	'historier',
	'flokk',
	'senger',
	'kanskje',
	'sjokolade',
	'hjul',
	'rundt',
	'sild',
	'skjelven',
	'godt',
	'kyllinger',
	'kjøtt',
	'smarttelefon',
	'fugl',
	'sykkelhjelm',
	'hjerte',
	'kjeveortoped',
	'blåbærsyltetøy',
	'biblioteket',
	'kjetting',
	'sannsyn',
	'abrakadabra',
];

export const wdAnswers = [
	'korleis',
	'verda',
	'magisk',
	'ski',
	'leksefri',
	'flokk',
	'kanskje',
	'rundt',
	'kyllingar',
	'blåbærsyltetøy',
	'biblioteket',
	'sannsyn',
	'abrakadabra',
];

export const rnIntroSteps = [
	'Intro',
	'Colors',
	'Images',
	'Colors and Images',
	'Ready to start',
];

export const rnNormingIntroSteps = [
	'Intro',
	'Colors and Images',
	'Ready to start',
];

export const rnAnswers = [
	[
		{color: 'red', item: 'bike'},
		{color: 'blue', item: 'teddy'},
		{color: 'grey', item: 'apple'},
		{color: 'red', item: 'bike'},
		{color: 'blue', item: 'sweater'},
		{color: 'orange', item: 'thumb'},
		{color: 'green', item: 'bike'},
	],
	[
		{color: 'grey', item: 'thumb'},
		{color: 'red', item: 'apple'},
		{color: 'orange', item: 'bike'},
		{color: 'orange', item: 'thumb'},
		{color: 'blue', item: 'sweater'},
		{color: 'green', item: 'teddy'},
		{color: 'blue', item: 'thumb'},
	],
	[
		{color: 'grey', item: 'apple'},
		{color: 'red', item: 'teddy'},
		{color: 'red', item: 'sweater'},
		{color: 'green', item: 'bike'},
		{color: 'grey', item: 'bike'},
		{color: 'blue', item: 'sweater'},
		{color: 'green', item: 'apple'},
	],
	[
		{color: 'orange', item: 'thumb'},
		{color: 'red', item: 'sweater'},
		{color: 'blue', item: 'apple'},
		{color: 'green', item: 'teddy'},
		{color: 'blue', item: 'thumb'},
		{color: 'green', item: 'teddy'},
		{color: 'orange', item: 'apple'},
	],
	[
		{color: 'grey', item: 'thumb'},
		{color: 'red', item: 'bike'},
		{color: 'orange', item: 'bike'},
		{color: 'grey', item: 'sweater'},
		{color: 'orange', item: 'bike'},
		{color: 'grey', item: 'sweater'},
		{color: 'orange', item: 'thumb'},
	],
	[
		{color: 'red', item: 'teddy'},
		{color: 'green', item: 'apple'},
		{color: 'grey', item: 'teddy'},
		{color: 'green', item: 'sweater'},
		{color: 'orange', item: 'apple'},
		{color: 'red', item: 'sweater'},
		{color: 'green', item: 'apple'},
	],
	[
		{color: 'grey', item: 'thumb'},
		{color: 'blue', item: 'teddy'},
		{color: 'grey', item: 'bike'},
		{color: 'orange', item: 'thumb'},
		{color: 'blue', item: 'sweater'},
		{color: 'green', item: 'teddy'},
		{color: 'red', item: 'apple'},
		{color: 'blue', item: 'teddy'},
	],
];
export const kdrnAnswers = [
	[
		{color: 'red', item: 'bike'},
		{color: 'blue', item: 'teddy'},
		{color: 'grey', item: 'apple'},
		{color: 'red', item: 'bike'},
		{color: 'blue', item: 'sweater'},
		{color: 'orange', item: 'thumb'},
	],
	[
		{color: 'green', item: 'bike'},
		{color: 'grey', item: 'thumb'},
		{color: 'red', item: 'apple'},
		{color: 'orange', item: 'bike'},
		{color: 'orange', item: 'thumb'},
		{color: 'blue', item: 'sweater'},
	],
	[
		{color: 'green', item: 'teddy'},
		{color: 'blue', item: 'thumb'},
		{color: 'grey', item: 'apple'},
		{color: 'red', item: 'teddy'},
		{color: 'red', item: 'sweater'},
		{color: 'green', item: 'bike'},
	],
	[
		{color: 'grey', item: 'bike'},
		{color: 'blue', item: 'sweater'},
		{color: 'green', item: 'apple'},
		{color: 'orange', item: 'thumb'},
		{color: 'red', item: 'sweater'},
		{color: 'blue', item: 'apple'},
		{color: 'green', item: 'teddy'},
	],
];
export const smallGradeRapidNamingNormingAnswers = [
	[
		{color: 'yellow', item: 'apple', language: 'Gult'}, // yellowapple
		{color: 'green', item: 'cake'}, // greencake
		{color: 'blue', item: 'bike'}, // bluebike
		{color: 'red', item: 'star'}, // redstar
		{color: 'brown', item: 'apple', language: 'Brunt'}, // brownapple
		{color: 'yellow', item: 'moon'}, // yellowmoon
	],
	[
		{color: 'green', item: 'bike'}, // greenbike
		{color: 'blue', item: 'star'}, // bluestar
		{color: 'brown', item: 'cake'}, // browncake
		{color: 'yellow', item: 'bike'}, // yellowbike
		{color: 'green', item: 'apple', language: 'Grønt'}, // greenapple
		{color: 'red', item: 'moon'}, // redmoon
	],
	[
		{color: 'brown', item: 'bike'}, // brownbike
		{color: 'blue', item: 'apple', language: 'Blått'}, // blueapple
		{color: 'red', item: 'cake'}, // redcake
		{color: 'yellow', item: 'star'}, // yellowstar
		{color: 'blue', item: 'moon'}, // bluemoon
		{color: 'brown', item: 'star'}, // brownstar
	],
	[
		{color: 'red', item: 'bike'}, // redbike
		{color: 'green', item: 'moon'}, // greenmoon
		{color: 'yellow', item: 'star'}, // yellowstar2 (duplicate)
		{
			color: 'red',
			item: 'apple',
			language: 'Raudt',
		}, // redapplely
		{color: 'blue', item: 'cake'}, // bluecake
		{color: 'brown', item: 'moon'}, // brownmoon
		{color: 'green', item: 'star'}, // greenstar
	],
];

// Revised Rapid Naming norming sequence (5 rows x 10 items = 50)
export const rnNormingAnswers = [
	[
		{color: 'blue', item: 'bike'}, // 1. blå sykkel
		{
			color: 'red',
			item: 'apple',
			language: 'Raudt',
		}, // 2. rødt eple
		{color: 'green', item: 'moon'}, // 3. grønn måne
		{color: 'brown', item: 'cake'}, // 4. brun kake
		{color: 'yellow', item: 'star'}, // 5. gul stjerne
		{color: 'blue', item: 'apple', language: 'Blått'}, // 6. blå eple
		{color: 'green', item: 'bike'}, // 7. grønn sykkel
		{color: 'red', item: 'star'}, // 8. rød stjerne
		{color: 'brown', item: 'moon'}, // 9. brun måne
		{color: 'yellow', item: 'cake'}, // 10. gul kake
	],
	[
		{color: 'green', item: 'apple', language: 'Grønt'}, // 11. grønt eple
		{color: 'blue', item: 'star'}, // 12. blå stjerne
		{color: 'red', item: 'moon'}, // 13. rød måne
		{color: 'brown', item: 'bike'}, // 14. brun sykkel
		{color: 'yellow', item: 'apple', language: 'Gult'}, // 15. gult eple
		{color: 'green', item: 'cake'}, // 16. grønn kake
		{color: 'blue', item: 'moon'}, // 17. blå måne
		{color: 'red', item: 'bike'}, // 18. rød sykkel
		{color: 'brown', item: 'apple', language: 'Brunt'}, // 19. brunt eple
		{color: 'yellow', item: 'moon'}, // 20. gul måne
	],
	[
		{color: 'blue', item: 'cake'}, // 21. blå kake
		{color: 'green', item: 'star'}, // 22. grønn stjerne
		{color: 'red', item: 'cake'}, // 23. rød kake
		{color: 'yellow', item: 'bike'}, // 24. gul sykkel
		{color: 'brown', item: 'star'}, // 25. brun stjerne
		{color: 'blue', item: 'moon'}, // 26. blå måne
		{color: 'green', item: 'apple', language: 'Grønt'}, // 27. grønt eple
		{color: 'yellow', item: 'star'}, // 28. gul stjerne
		{color: 'red', item: 'bike'}, // 29. rød sykkel
		{color: 'brown', item: 'cake'}, // 30. brun kake
	],
	[
		{color: 'green', item: 'moon'}, // 31. grønn måne
		{color: 'blue', item: 'bike'}, // 32. blå sykkel
		{color: 'yellow', item: 'apple', language: 'Gult'}, // 33. gult eple
		{color: 'red', item: 'star'}, // 34. rød stjerne
		{color: 'brown', item: 'moon'}, // 35. brun måne
		{color: 'blue', item: 'cake'}, // 36. blå kake
		{color: 'green', item: 'bike'}, // 37. grønn sykkel
		{color: 'yellow', item: 'moon'}, // 38. gul måne
		{
			color: 'red',
			item: 'apple',
			language: 'Raudt',
		}, // 39. rødt eple
		{color: 'brown', item: 'star'}, // 40. brun stjerne
	],
	[
		{color: 'green', item: 'cake'}, // 41. grønn kake
		{color: 'blue', item: 'star'}, // 42. blå stjerne
		{color: 'yellow', item: 'bike'}, // 43. gul sykkel
		{color: 'red', item: 'moon'}, // 44. rød måne
		{color: 'blue', item: 'apple', language: 'Blått'}, // 45. blå eple
		{color: 'green', item: 'star'}, // 46. grønn stjerne
		{color: 'yellow', item: 'cake'}, // 47. gul kake
		{color: 'brown', item: 'apple', language: 'Brunt'}, // 48. brunt eple
		{color: 'red', item: 'cake'}, // 49. rød kake
		{color: 'brown', item: 'bike'}, // 50. brun sykkel
	],
];
